import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL_V1 } from "../../../api";
export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: API_URL_V1,
        // global configuration for the api
        refetchOnReconnect: true,
        prepareHeaders: async (headers, { getState, endpoint }) => {
            const token = getState()?.auth?.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        },
    }),
    tagTypes: [],
    endpoints: (builder) => ({}),
});
